// src/utils/auth.js
//
// 비밀번호는 서버(.env의 ADMIN_PASSWORD)에서만 알고 있고, 프론트엔드 번들에는
// 절대 박혀있지 않다. 로그인은 POST /api/admin/auth/login 으로 검증하고,
// 통과 시 받은 토큰을 localStorage("adminToken")에 보관한다.
// 이후 모든 /api/admin/* 요청에는 setupAdminAuth.js의 인터셉터가
// Authorization: Bearer <토큰> 헤더를 자동 부착한다.

const TOKEN_KEY = "adminToken";

export const getAdminToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY) || "";
  } catch {
    return "";
  }
};

export const setAdminToken = (token) => {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {}
};

export const clearAdminToken = () => {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {}
};

/**
 * 비밀번호로 서버 로그인 시도. 성공하면 토큰을 저장하고 true 반환.
 */
export const loginAdmin = async (password) => {
  const res = await fetch("/api/admin/auth/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ password }),
  });

  if (res.status === 429) {
    const retry = res.headers.get("Retry-After") || "60";
    const err = new Error(`너무 많은 시도입니다. ${retry}초 뒤 다시 시도하세요.`);
    err.code = 429;
    throw err;
  }
  if (!res.ok) {
    return false; // 401 등 → 비밀번호 불일치
  }

  const data = await res.json();
  if (!data?.token) return false;
  setAdminToken(data.token);
  return true;
};

/**
 * 보유 토큰이 서버에서 아직 유효한지 확인. (PrivateRoute 마운트 시 1회 호출)
 */
export const verifyAdminToken = async () => {
  const token = getAdminToken();
  if (!token) return false;
  try {
    const res = await fetch("/api/admin/auth/check", {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) {
      clearAdminToken();
      return false;
    }
    return true;
  } catch {
    return false;
  }
};

export const logoutAdmin = () => {
  clearAdminToken();
};

// ───────────────────────────────────────────────
// 하위 호환 (기존 컴포넌트가 import하던 이름들)
// ───────────────────────────────────────────────

/** 토큰 존재 여부만 빠르게 검사 (서버 검증 X). PrivateRoute의 1차 게이트로 사용. */
export const isAdminAuthenticated = () => Boolean(getAdminToken());
export const isAuthenticated = isAdminAuthenticated;

/**
 * 기존 시그니처 호환: 비밀번호를 받아 동기적으로 boolean을 돌려주던 함수.
 * 더 이상 동기적 검증은 불가능 — Promise<boolean>을 반환한다.
 * 새 코드는 loginAdmin(password)를 사용하라.
 */
export const setAdminAuthenticated = (password) => loginAdmin(password);
